import { getConfig } from '@testing-library/react';
import Core from '../core';

function getComplaintListByEmp(empId: number, fromDate: any, toDate: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/complaints/byEmployee?empId=${empId}&statusType=undefined&from_date=${fromDate}&to_Date=${toDate}&event=${'complaint'}&limit=${9999}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCompanyEmployees(
  companyId: number,
  page: number,
  rowsPerPage: number,
  searchText: string,
  selectAll?: number,
  depID?: any,
) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .get(`/v1/getCompanyEmployees`, {
        params: {
          companyId: companyId,
          locale: localStorage.getItem('applang'),
          deptId: depID,
          page: page,
          searchName: searchText,
          rowsPerPage: rowsPerPage,
          selectAll: selectAll ?? 0,
        },
      })
      .then((result: any) => {
        return resolve(result.data.data);
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
}

function submitApplicationHr(payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/hrAdmin/create`, payload)
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

export const complaintService = {
    getComplaintListByEmp,
    getCompanyEmployees,
    submitApplicationHr
};
